export default __webpack_public_path__ + "static/nanno_screen_1-db15e0e6b94ffb1c18f194844b2905e3.svg";